module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/~/axios/index.js
// module id = 151
// module chunks = 15